import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerInstances = {
  dockerInstances: {
    pageTitle: "Instance Management",
    pageSubtitle: "Create container instances, access consoles, and commit images",
    objects: {
      instance: "Instance",
    },
    summary: {
      total: "Total instances: {count}",
      running: "Running: {count}",
      stopped: "Stopped: {count}",
      withWebEndpoint: "With web endpoint: {count}",
    },
    table: {
      name: commonShortFieldLabels.name,
      kind: "Instance Type",
      image: "Image Identifier",
      status: commonShortNouns.status,
      webEndpoint: "Web Endpoint",
      portMapping: "Port Mapping",
      expiresAt: "Expires At",
      createdAt: commonShortFieldLabels.createdAt,
      actions: "Actions",
    },
    dialogs: {
      commitTitle: "Generate Image from Instance",
    },
    form: {
      imageName: "Image Identifier",
      imageNameRequired: "Enter an image identifier",
      imageNamePlaceholder: "Example: exam/practical-upload:snapshot-001",
      description: "Description",
      descriptionPlaceholder: "Image description",
      tags: "Tags (comma-separated)",
      tagsPlaceholder: "Example: v1.1,practical,web",
    },
    actions: {
      confirm: "Confirm",
      detailConsole: "Details / Console",
      start: "Start",
      stop: "Stop",
      commitImage: "Generate Image",
    },
    confirmDelete: {
      title: "Delete this instance?",
    },
    messages: {
      started: "Instance started",
      stopped: "Instance stopped",
      deleted: "Instance deleted",
      imageCommitted: "Image generated: {name}",
      defaultCommitDescription: "from container {containerId}",
    },
  },
  dockerInstanceCreate: {
    title: "Create Instance",
    imagePickerTitle: "Select Image (name / identifier)",
    table: {
      image: "Image Identifier",
      declaredPorts: "Declared Ports",
      effectivePorts: "Effective Ports",
      description: "Description",
      actions: "Actions",
    },
    form: {
      kind: "Instance Type",
      kindRequired: "Select an instance type",
      kindWeb: "Web (mapped port)",
      kindGeneric: "Generic (no mapped port)",
      name: "Instance Name",
      namePlaceholder: "Optional, auto-generated by default",
      image: "Image Identifier",
      imageRequired: "Select an image identifier",
      imagePlaceholder: "Search by image name or image identifier",
      chooseFromList: "Choose from the image name / identifier list",
      chooseImageHint:
        "Filter by image name or identifier in the dialog and fill the image identifier",
      containerPort: "Container Internal Port",
      containerPortRequired: "Enter the container internal port",
      containerPortHint:
        "Only valid for web type: maps to a random host port (`host_port:container_port`), not a manually specified host port.",
      ttlMinutes: "Expiration Time (minutes)",
      ttlRequired: "Enter TTL",
      inputMode: "Parameter Input Mode",
      inputModeForm: "Form Mode",
      inputModeJson: "Structured Parameter Mode",
      paramsJson: "Structured Parameters",
      cpuLimit: "CPU Limit (cores)",
      memoryLimit: "Memory Limit (MB)",
      consoleInteraction: "Console Interaction",
      tty: "Terminal Mode (-t)",
      stdinOpen: "Standard Input (-i)",
      envVars: "Environment Variables",
      addEnvVar: "Add Environment Variable",
      envKeyRequired: "Enter a variable name",
      envKeyPlaceholder: "Variable name (e.g. NODE_ENV)",
      envValuePlaceholder: "Variable value (e.g. production)",
      entrypointArgs: "Entrypoint Arguments",
      addEntrypointArg: "Add Entrypoint Argument",
      arg: "Argument",
      entrypointArgPlaceholder: "The first item is the entrypoint command, followed by arguments",
      commandArgs: "Command Arguments",
      addCommandArg: "Add Command Argument",
      commandArgPlaceholder: "Pass command arguments in order",
      imageKeywordPlaceholder: "Enter image name or image identifier to filter",
      selectImage: "Select",
    },
    messages: {
      jsonMustBeObject: "JSON parameters must be an object",
      jsonInvalid: "Invalid JSON format",
      createSuccess: "Instance created successfully",
    },
  },
  dockerInstanceDetail: {
    pageTitle: "Instance Detail",
    notFound: "No matching instance was found.",
    sections: {
      basicInfo: "Basic Information",
      callbackInfo: "Callback Information",
      runtimeData: "Runtime Data",
      webConsole: "Web Console",
    },
    fields: {
      name: commonShortFieldLabels.name,
      status: commonShortNouns.status,
      containerId: "Container ID",
      image: "Image Identifier",
      kind: "Type",
      webEndpoint: "Web Endpoint",
      hostPort: "Host Port",
      containerPort: "Container Port",
      checkMode: "Check Mode",
      ttyStdin: "Terminal Mode / Standard Input",
      createdAt: commonShortFieldLabels.createdAt,
      updatedAt: commonShortFieldLabels.updatedAt,
      expiresAt: "Expires At",
      mode: "Mode",
      scriptPath: "Script Path",
      callbackUrl: "Callback URL",
      callbackToken: "Callback Token",
    },
    console: {
      description:
        "Enter a shell command to run inside the container (based on `docker exec -i`; `-t` is added when terminal mode is enabled).",
      placeholder: "Example: id && pwd && ls -la",
      runCommand: "Run Command",
      clearOutput: "Clear Output",
      outputPlaceholder: "Command output will appear here",
    },
    actions: {
      copyUrl: "Copy URL",
      copyToken: "Copy Token",
    },
    messages: {
      execCompleted: "Execution completed: {status}",
      emptyValue: "{label} is empty",
      copySuccess: "{label} copied",
      copyFailed: "Failed to copy {label}",
    },
  },
} as const;
